var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.304,
    height: 24.102,
    viewBox: "0 0 13.304 24.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M15.949.437a1.214,1.214,0,1,0-1.865,1.555,1.228,1.228,0,0,0,.155.155l8.725,8.735a1.818,1.818,0,0,1,0,2.432l-8.738,8.725a1.238,1.238,0,0,0,0,1.71,1.207,1.207,0,0,0,1.707,0l0,0L26.743,12.94a1.187,1.187,0,0,0,.032-1.678l-.032-.032Z",
    transform: "translate(-13.802)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSidebar);
export default __webpack_public_path__ + "static/media/arrow_sidebar.4197a1a5f283bf0c4fe7eead494c4c8c.svg";
export { ForwardRef as ReactComponent };